import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { useNotificationState, NotificationType } from '../../context/NotificationContext';

// --- Ícones para cada tipo de notificação ---
const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const InfoIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

// Remoção da anotação de tipo explícita para deixar o TypeScript inferir
const notificationConfig = {
    success: {
        Icon: CheckIcon,
        title: 'Sucesso!',
    },
    error: {
        Icon: ErrorIcon,
        title: 'Ocorreu um Erro',
    },
    info: {
        Icon: InfoIcon,
        title: 'Aviso',
    },
};

export function NotificationBanner() {
    const { isVisible, message, type } = useNotificationState();
    // Acessa o tipo de forma segura
    const config = notificationConfig[type as NotificationType] || notificationConfig.info;
    const { Icon, title } = config;

    return (
        <div
            aria-live="assertive"
            className="fixed inset-0 flex items-start justify-center px-4 py-6 pointer-events-none sm:p-6 z-[100]"
        >
            <div className="w-full max-w-sm">
                <Transition
                    show={isVisible}
                    as={Fragment}
                    enter="transform ease-out duration-300 transition"
                    enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                    enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                        <div className="p-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0">
                                    <Icon />
                                </div>
                                <div className="ml-3 w-0 flex-1 pt-0.5">
                                    <p className="text-sm font-medium text-gray-900">{title}</p>
                                    <p className="mt-1 text-sm text-gray-500">{message}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    );
}